module.exports = __webpack_public_path__ + "01f720107f5648e92595dfd5e98ba611.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mshgzh.jpg
// module id = 272
// module chunks = 1